export const SAVE_PROJECT = "saveProject";
export const LOAD_PROJECT = "loadProject";
export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const LOAD_TOOLTIPS = "loadTooltips";